import { sendDataToBuffer } from "../../util/Api/sendDataToBuffer";
import { sendMultiplePrescriptions } from "../../util/Api/sendMultiplePrescriptions";
import { sendMedicalQuestionnaire } from "../../util/Api/sendMedicalQuestionnaire";
import { sendDigaRedeem } from "../../util/Api/sendDigaRedeem";
import { sendEncryptedEmail } from "../../util/Api/sendEncryptedEmail";
import { Field, StepData } from "../FormViewer/FormViewer.types";
import { SessionLayer } from "../../interfaces";

export const handleApiRequest = async (apiEndpoint: string, requestConditions: any) => {
  const { is_last_step, hasSuccessStep, disablePartialLeads } = requestConditions;
  const formCompleted = is_last_step || hasSuccessStep;
  const { lead } = window.sessionLayer as { lead: SessionLayer };
  const all_fields = [] as Array<Field>;

  lead?.lead_data.forEach((step: StepData) => {
    const { fields } = step;
    fields?.forEach((field: Field) => {
      all_fields.push(field);
    })
  });

  lead?.push_data?.forEach((f: any) => {
    const field = {
      field_crm_id: f.crm_field,
      field_value: f.crm_value
    }
    
    all_fields.push(field);
  });

  if(apiEndpoint === "multiple_prescriptions") {
    if(all_fields?.some((field: Field) => field.field_crm_id === "prescriptions")) {
      const response = await sendMultiplePrescriptions(window.sessionLayer.lead, requestConditions);
      return response;
    }
  }

  else if(apiEndpoint === "anamnesis") {
    if (formCompleted) {
      const response = await sendMedicalQuestionnaire(window.sessionLayer.lead, requestConditions);
      return response;
    }
  }

  else if(apiEndpoint === "diga_redeem") {
    if (formCompleted) {
      const response = await sendDigaRedeem(window.sessionLayer.lead, requestConditions);
      return response;
    }
  }


  else if(apiEndpoint === "encrypted_email") {
    if (formCompleted) {
      const response = await sendEncryptedEmail(window.sessionLayer.lead, requestConditions);
      return response;
    }
  }

  else {
    if (all_fields?.some((field: Field) => field.field_crm_id === "email" || field.field_crm_id === "contact_id" || field.field_crm_id === "phone")) {
      if ((!is_last_step && !hasSuccessStep) && disablePartialLeads) return;
      const response = await sendDataToBuffer(window.sessionLayer.lead, requestConditions);
      return response;
    }
  }
}